import { colorGrey05 } from "../../../../layout/css/colors";

export const RoomScheduleCardStyle = { marginTop: 1, marginBottom: 1 };
export const RoomInfoHeaderStyle = { bgcolor: colorGrey05, p: 1 };
export const GuestScheduleItemStyle = { display: 'flex', flexDirection: 'column', alignItems: 'center' };